import { Card, Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeftOutlined, CalendarOutlined } from "@ant-design/icons";
import { hackathonApi, type Hackathon } from "../services/hackathon";

const AssignResources = () => {
  const navigate = useNavigate();

  // Fetch hackathons
  const { data: hackathonsData, isLoading } = useQuery({
    queryKey: ["hackathons"],
    queryFn: hackathonApi.getHackathons,
  });

  const hackathons = hackathonsData?.data || [];
  const activeHackathons = hackathons.filter(
    (hackathon) => hackathon.isActive === true
  );

  const handleHackathonSelect = (hackathon: Hackathon) => {
    navigate(`/resources/assign-resources/${hackathon._id}`);
  };

  const handleBack = () => {
    navigate("/resources");
  };

  return (
    <div className="p-6 h-full flex flex-col">
      {/* Header */}
      <div className="mb-6">
        <div className="flex flex-col gap-6 items-start">
        

          <Button 
          type="text" 
          icon={<ArrowLeftOutlined />}
          onClick={handleBack}
          className="text-gray-600 hover:text-gray-900 p-2 h-auto font-medium"
        >
          Back
        </Button>
          <h1 className="text-2xl font-semibold text-gray-900">
            Assign Resources
          </h1>
        </div>
      
      </div>

      {/* Hackathons Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 flex-1">
        {isLoading ? (
          // Loading skeleton
          <>
            {[...Array(6)].map((_, index) => (
              <Card key={index} className="bg-white border border-gray-200">
                <div className="flex flex-col gap-4">
                  <div className="w-full h-32 bg-gray-200 rounded-lg animate-pulse"></div>
                  <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                  <div className="h-3 bg-gray-200 rounded animate-pulse w-3/4"></div>
                  <div className="h-3 bg-gray-200 rounded animate-pulse w-1/2"></div>
                </div>
              </Card>
            ))}
          </>
        ) : activeHackathons.length === 0 ? (
          <div className="col-span-full flex flex-col justify-center items-center py-16">
            <div className="text-center">
              <div className="text-gray-400 text-6xl mb-4">🏆</div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                No Active Hackathons
              </h3>
              <p className="text-gray-500 mb-6">
                There are currently no active hackathons to assign resources to.
              </p>
              <Button
                type="primary"
                onClick={() => navigate("/hackathons")}
                className="bg-primary hover:bg-primary/90"
              >
                Manage Hackathons
              </Button>
            </div>
          </div>
        ) : (
          activeHackathons.map((hackathon) => (
            <Card
              key={hackathon._id}
              className="bg-white border border-gray-200 hover:shadow-md transition-shadow cursor-pointer !py-0"
              onClick={() => handleHackathonSelect(hackathon)}
            >
              <div className="flex items-start gap-4">
                {/* Hackathon Image */}
                <div className="h-full rounded-lg overflow-hidden flex-  flex items-center justify-center">
                  {hackathon.photo ? (
                    <img
                      src={hackathon.photo}
                      alt={hackathon.title}
                      className="w-[100px] h-full object-cover"
                    />
                  ) : (
                    <div className="text-gray-400 text-4xl">🏆</div>
                  )}
                </div>

                <div className="flex flex-col gap-2 flex-1">
                  {/* Title */}
                  <h3 className="text-sm font-semibold text-gray-900">
                    {hackathon.title}
                  </h3>

                  {/* Description */}
                  <p className="text-xs text-gray-600 leading-relaxed">
                    {hackathon.description || "No description available"}
                  </p>

                  {/* Registration Info */}
                  <div className="flex flex-col  gap-1 text-xs text-gray-500">
                    <div className="flex items-center gap-1">
                      <CalendarOutlined className="w-4 h-4" />
                      <span>Registrations Starts:</span>
                    </div>
                    <span className="text-gray-900 text-xs">
                      {new Date(hackathon.startDate).toLocaleDateString(
                        "en-US",
                        {
                          weekday: "short",
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        }
                      )}{" "}
                      (GMT)
                    </span>
                  </div>
                </div>
              </div>
            </Card>
          ))
        )}
      </div>
    </div>
  );
};

export default AssignResources;
